
import { FilterOperators } from "@crispico/foundation-gwt-js";
import {
    EntityTablePage,
    EntityTablePageProps,
    EntityTablePageReducers,
    EntityTablePageState,
    Utils
} from "@crispico/foundation-react";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { addEntityDescriptor, EntityDescriptor, FieldDescriptor } from "@crispico/foundation-react/entity_crud/EntityDescriptor";
import { DatePickerFieldEditor } from "@crispico/foundation-react/entity_crud/fieldEditors/DatePickerFieldEditor";
import DateFieldRenderer from "@crispico/foundation-react/entity_crud/fieldRenderers/DateFieldRenderer";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { ReduxReusableComponents } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";

class HistoryTrackTablePage extends EntityTablePage<EntityTablePageProps> {

    constructor(props: EntityTablePageProps) {
        super(props);

        this.setOptions({ countMode: undefined });
    }
}

const HistoryTrackTablePageRRC = ReduxReusableComponents.connectRRC(EntityTablePageState, EntityTablePageReducers, HistoryTrackTablePage);

export class HistoryTrackEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "HistoryTrack",
            icon: "truck",
            defaultFilter: Filter.createForClient("startTime", FilterOperators.forDate.today, ''),
            defaultSort: { field: "startTime", direction: "DESC" }
        });
    }

    renderTable() {
        return <HistoryTrackTablePageRRC {...super.renderTable().props} ref={this.entityTablePage} />;
    }
}

export const historyTrackEntityDescriptor = addEntityDescriptor(new HistoryTrackEntityDescriptor()  
    .addFieldDescriptor({
        name: "startTime", type: FieldType.date,
        additionalFieldEditorProps: FieldDescriptor.castAdditionalFieldEditorProps(DatePickerFieldEditor, { format: Utils.dateTimeWithSecFormat }),
        additionalFieldRendererProps: FieldDescriptor.castAdditionalFieldRendererProps(DateFieldRenderer, { format: Utils.dateTimeWithSecFormat })
    })
    .addFieldDescriptor({
        name: "endTime", type: FieldType.date,
        additionalFieldEditorProps: FieldDescriptor.castAdditionalFieldEditorProps(DatePickerFieldEditor, { format: Utils.dateTimeWithSecFormat }),
        additionalFieldRendererProps: FieldDescriptor.castAdditionalFieldRendererProps(DateFieldRenderer, { format: Utils.dateTimeWithSecFormat })
    })
    .addFieldDescriptor({ name: "equipmentResource", type: "EquipmentResource" })
    .addFieldDescriptor({ name: "startEngineHours", type: FieldType.double })
    .addFieldDescriptor({ name: "endEngineHours", type: FieldType.double })
    .addFieldDescriptor({ name: "startOdometer", type: FieldType.double })
    .addFieldDescriptor({ name: "endOdometer", type: FieldType.double })
);
